import React from 'react';
import { Loader } from 'components/atoms';
import CoreErrorAlert from 'components/organisms/core-error-alert';

export interface Props {
  children: React.ReactElement;
  loading?: boolean;
  className?: string;
}
const ExpertHubFullWidthWithoutTopbarLayout = ({ children, loading, className }: Props) => (
  <Loader loading={loading ?? false}>
    <div
      className={`container-fluid layout-container ${className}`}
    >
      <CoreErrorAlert />
      {children}
    </div>
    {/* <Footer /> */}
  </Loader>
);

ExpertHubFullWidthWithoutTopbarLayout.defaultProps = {
  loading: false,
  className: '',
};

export default ExpertHubFullWidthWithoutTopbarLayout;
